/**
 * @class
 * @extends {Array}
 */
class ConfigList extends Array {}

export default ConfigList;
